import { useMsal } from "@azure/msal-react";
import { Anchor, Box, Button, Grid, Heading, Image, Markdown, ResponsiveContext, Stack, Tab, Tabs, Text } from "grommet";
import * as React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CertificateGenerator } from "./CertificateGenerator";
import EditProfile, { isProfileComplete } from "./EditProfile";
import KnowledgeCheck from "./KnowledgeCheck";
import ManageOrganization from "./ManageOrganization";
import { loginRequest } from "./authConfig";
import { useDarkMode } from "./components/DarkModeSwitch";
import { download, save } from "./components/Download";
import SkeletonWrapper from "./components/SkeltonWrapper";
import { TaskList } from "./components/TaskList";
import { CONTEXTCLAIMTYPE, MEMBERSHIPCLAIMTYPE, useUser } from "./utils/AccountStore";
import { GetGuides, GetOrganization, ListStorage, Organization } from "./utils/IdentityAPI";
import localize, { localizePairs, RulesText } from "./utils/LocalizationStore";
import { GetMaps } from "./utils/SportAPI";
import LocalizedText from "./components/LocalizedText";
import StyledModal from "./components/StyledModel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { size } from "lodash";
import OrganizationCertificates from "./OrganizationCertificates";
import AsteroidsGame from "./components/AsterioidsGame";
import ProcessGraph from "./components/ProcessGraph";
import Countdown from "./components/Countdown";

let Home = () => {
    const [isDarkMode, toggleDarkMode] = useDarkMode();

    const [metadata, setMetdata] = React.useState({ showCertificates: true, showDownloads: false } as { showCertificates: boolean; showDownloads: boolean });
    let [loading, setLoading] = React.useState(true);
    const [showGuides, setShowGuides] = React.useState(false);

    const { instance } = useMsal();

    let { user, setUser } = useUser();

    React.useEffect(() => {
        if (user.isAuthenticated) {
            let context = user.claims.filter((c) => c.type == CONTEXTCLAIMTYPE)[0].value;
            if (context) {
                let tasks = [] as any[];

                // tasks.push({ id: "registerOrganization", name: "Register your school", complete: false });

                if (tasks.every((t) => t.complete)) {
                    tasks = [];
                }

                setTasks(tasks);
            }

            setLoading(false);
        }
    }, [user]);

    const [tasks, setTasks] = React.useState([] as any[]);

    const maxSize = screen?.width > 800 ? "250px" : "100%";
    const logoMaxSize = screen?.width > 600 ? "200px" : "75%";

    const size = React.useContext(ResponsiveContext);

    const [gridAreas, setGridAreas] = React.useState([] as any[]);
    const [columns, setColumns] = React.useState([] as any[]);

    React.useEffect(() => {
        if (size == "small") {
            setGridAreas([
                { name: "header", start: [0, 0], end: [0, 0] },
                { name: "main", start: [0, 1], end: [0, 1] },
            ]);
            setColumns(["auto"]);
        } else {
            setGridAreas([
                { name: "header", start: [0, 0], end: [1, 0] },
                { name: "main", start: [0, 1], end: [0, 1] },
                { name: "ad", start: [1, 1], end: [1, 1] },
            ]);
            setColumns(["auto", "1/4"]);
        }
    }, [size]);

    const copyText = (text) => {
        navigator?.clipboard?.writeText(text).then(
            () => {
                /* clipboard successfully set */
                setShowCopyAlert(true);
                setCopySuccess(true);
            },
            () => {
                /* clipboard write failed */
                setShowCopyAlert(true);
                setCopySuccess(false);
            }
        );
    };

    return (
        <div>
            <AsteroidsGame style={{ opacity: 0.1 }}></AsteroidsGame>
            {user && (
                <Box align="center">
                    <Image margin="small" alignSelf="center" fit="contain" src={isDarkMode ? "/images/hp_logo_white.png" : "/images/hp_logo_black.png"} width={logoMaxSize} />
                    <Heading level={2} margin="small">
                        GameOn with HP Gaming Garage
                    </Heading>

                    <Box style={{ position: "relative" }}>
                        <KnowledgeCheck onChange={() => {}}></KnowledgeCheck>
                        <Box direction={size != "small" ? "row" : "column"} gap="small" align="center">
                            <Box>
                                <Markdown>{RulesText}</Markdown>
                                <Image margin="small" alignSelf="center" fit="contain" src={"/images/rage.png"} />
                            </Box>
                            <ProcessGraph></ProcessGraph>
                        </Box>
                        {size != "small" && (
                            <Box style={{ position: "absolute", right: "100%" }}>
                                <Image margin="small" alignSelf="center" fit="contain" src="/images/hp-splash-v.jpg" width={maxSize} />
                            </Box>
                        )}
                    </Box>
                </Box>
            )}
        </div>
    );
};

export default Home;
